import { createStore, applyMiddleware } from "redux";

// Initial state
const initialState = {
  sidebarShow: true,
  isNavigating: false,
  lastNavTime: 0,
  currentRoute: null,
  routeCache: {},
  previousContent: null,
  organizations: [],
  organizationsFetched: false,
  menuList: [],
  menuListFetched: false,
  userActions: [],
  showQrCode: false,
};

// Simplified middleware - no throttling or delays
const navigationMiddleware = (store) => (next) => (action) => {
  if (action.type === "set" && action.navigationRequest) {
    action = {
      ...action,
      isNavigating: false,
      previousContent: null,
    };
  }

  // Cache route when one is found
  if (action.type === "cacheRoute" && action.path && action.routeData) {
    const state = store.getState();
    return next({
      type: "set",
      routeCache: {
        ...state.routeCache,
        [action.path]: action.routeData,
      },
    });
  }

  return next(action);
};

// Reducer
const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case "set":
      return { ...state, ...rest };
    default:
      return state;
  }
};

// Create store with middleware
const store = createStore(changeState, applyMiddleware(navigationMiddleware));

export default store;
